import { z } from 'zod';

export const GetDetailsResponseSchema = z.object({
  name: z.string(),
  dateFrom: z.string(),
  dateTo: z.string(),
  budget: z.string(),
  lastApprovedMediaPlanItem: z.object({
    id: z.number(),
    mediaPlan: z.number(),
    dateFrom: z.string(),
    dateTo: z.string(),
    budget: z.number(),
    overriddenCurrency: z.string().nullable(),
  }),
});

export type GetDetailsResponseType = z.infer<typeof GetDetailsResponseSchema>;

export const MediaRowSchema = z.object({
  name: z.string(),
  channelName: z.string(),
  tileId: z.number(),
});

export const PreviewQuerySchema = z.object({
  campaignCollectionId: z.number(),
  platformName: z.string().nullable().optional(),
  channelName: z.string().nullable().optional(),
  withDates: z.boolean().optional(),
});
